import React from 'react';
import { Typography } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import './EmptyState.scss';

const { Title, Text } = Typography;

interface EmptyStateProps {
  title: string;
  description?: string;
  action?: React.ReactNode;
}

const EmptyState = ({ title, description, action }: EmptyStateProps) => {
  return (
    <div className="EmptyState">
      <InboxOutlined className="EmptyState__icon" />
      <Title level={5} className="EmptyState__title">
        {title}
      </Title>
      {description && (
        <Text type="secondary" className="EmptyState__description">
          {description}
        </Text>
      )}
      {action && <div className="EmptyState__action">{action}</div>}
    </div>
  );
};

export default EmptyState;
